import React, { useState } from "react";
import ReactSVG from "react-svg";
import { withTranslation } from "react-i18next";
import moment from "moment/moment";
import cx from "classnames";
import baseService from "../../../services/BaseService";
import Loader from "../../Loader";
import QRCode from "react-qr-code";
import { ModalWindow } from "ui-core-dashboard";
import MessageModal from "../../MessageModal";

function QRCodeChannels(props) {
    const { t, channels, isLoading, canEditNotificationChannels } = props;

    const [isBotLoading, setIsBotLoading] = useState({});

    const [qrCode, setQrCode] = useState({});

    const [confirmModal, setConfirmModal] = useState({
        open: false,
        itemId: null,
        itemName: "",
        message: t("deleteTelegramDeviceConfirm"),
        primaryButton: t("remove"),
        secondaryButton: t("cancel"),
    });

    function onQrCodeClose(botName) {
        setQrCode(prev => ({ ...prev, [botName]: "" }));
        if (props.onQrCodeClose && typeof props.onQrCodeClose === "function") {
            props.onQrCodeClose();
        }
    }

    function handleAddDevice(botName) {
        setIsBotLoading(prev => ({ ...prev, [botName]: true }));
        return baseService
            .get("addBot", { pathParams: { botName } })
            .then(({ result, success }) => {
                setIsBotLoading(prev => ({ ...prev, [botName]: false }));
                if (success) {
                    if (result && result.url) {
                        setQrCode(prev => ({ ...prev, [botName]: result.url }));
                    }
                }
            })
            .catch(e => {
                setIsBotLoading(prev => ({ ...prev, [botName]: false }));
                console.error("QRCodeChannels::handleAddDevice: Error during request: ", e);
            });
    }

    function closeConfirmModal(e) {
        if (e) {
            console.log({ e });
        }
        setConfirmModal(prev => ({
            ...prev,
            open: false,
            itemId: null,
            itemName: "",
            botName: "",
        }));
    }

    function openConfirmModal(botName, itemId, itemName) {
        setConfirmModal(prev => ({
            ...prev,
            open: true,
            botName,
            itemId,
            itemName,
        }));
    }

    function handleRemoveDevice(botName, id) {
        closeConfirmModal();
        setIsBotLoading(prev => ({ ...prev, [botName]: true }));
        return baseService
            .delete("deleteBot", { pathParams: { botName, id } })
            .then(({ success }) => {
                setIsBotLoading(prev => ({ ...prev, [botName]: false }));
                if (success) {
                    if (props.onChannelRemove && typeof props.onChannelRemove === "function") {
                        props.onChannelRemove();
                    }
                }
            })
            .catch(e => {
                setIsBotLoading(prev => ({ ...prev, [botName]: false }));
                console.error("QRCodeChannels::handleRemoveDevice: Error during request: ", e);
            });
    }

    function renderChannel(channel, index, botName) {
        const { id, label, createDate } = channel;
        return (
            <div
                className={cx("qr-code-channel", { "qr-code-channel--disabled": !canEditNotificationChannels })}
                title={`${label} ${moment(createDate).format("DD.MM.YY HH:mm:ss")}`}
                key={id}
            >
                <div className="qr-code-channel__name">
                    {label} <span>({moment(createDate).format("DD.MM.YY HH:mm:ss")})</span>
                </div>
                {canEditNotificationChannels && <div className="qr-code-channel__delete" onClick={() => openConfirmModal(botName, id, label)}>
                    <ReactSVG className="svg-delete" src="/data/svg/icon-bin.svg" alt="delete" />
                </div>}
            </div>
        );
    }

    function renderChannels(item) {
        const { name, botName, channels, addition } = item;
        return (
            <div className="qr-code-channels" key={botName}>
                {isBotLoading[botName] && <Loader />}
                <div className="qr-code-channels__header">
                    <div className="qr-code-channels__header-name">
                        {name} ({botName})
                    </div>
                    {addition && canEditNotificationChannels && (
                        <button
                            type="button"
                            disabled={qrCode[botName]}
                            className={cx("btn-save qr-code-channels__header-add", { disabled: qrCode[botName] })}
                            onClick={() => handleAddDevice(botName)}
                        >
                            +{t("add")}
                        </button>
                    )}
                </div>
                {qrCode[botName] && (
                    <div className="qr-code-channels__qr-code">
                        <button
                            type="button"
                            className="btn-save qr-code-channels__qr-code-close"
                            onClick={() => onQrCodeClose(botName)}
                        >
                            <ReactSVG className="svg-delete" src="/data/svg/close.svg" alt="delete" />
                        </button>
                        <a target="_blank" href={qrCode[botName]}>
                            <QRCode size={120} value={qrCode[botName]} />
                        </a>
                    </div>
                )}
                <div className="qr-code-channels__list">
                    {channels &&
                        channels.length > 0 &&
                        channels.map((item, index) => renderChannel(item, index, botName))}
                </div>
            </div>
        );
    }

    return (
        <div className="qr-code-channels__wrapper">
            {isLoading && <Loader />}
            {channels && channels.length > 0 && channels.map(renderChannels)}
            {confirmModal.open && (
                <ModalWindow
                    onClose={closeConfirmModal}
                    className="modal-small ordering-component-ui-core-wrapper ignore-clickoutside qr-channel-delete-modal"
                >
                    <MessageModal
                        titleModal={t("deleteConfirm")}
                        contentModalText={`${t(confirmModal.message)}: ${confirmModal.itemName}?`}
                        dangerButton
                        dangerButtonText={t(confirmModal.primaryButton)}
                        onClickDangerButton={() => handleRemoveDevice(confirmModal.botName, confirmModal.itemId)}
                        secondaryButton
                        secondaryButtonText={t(confirmModal.secondaryButton)}
                        onClickSecondaryButton={closeConfirmModal}
                    />
                </ModalWindow>
            )}
        </div>
    );
}

export default withTranslation()(QRCodeChannels);
